import { render, staticRenderFns } from "./CopyrightFormFiles.vue?vue&type=template&id=5ae85916&scoped=true&"
import script from "./CopyrightFormFiles.vue?vue&type=script&lang=js&"
export * from "./CopyrightFormFiles.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightFormFiles.vue?vue&type=style&index=0&id=5ae85916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae85916",
  null
  
)

export default component.exports